<template >
  <v-container class="container-veiculos-cadastro pt-0" grid-list-lg >
    <v-card-title class="white mb-4">
      <v-menu
        v-model="filtro.tipoVeiculo.opened"
        :close-on-content-click="false"
        offset-y
        transition="slide-y-transition"
        :full-width="$vuetify.breakpoint.smAndDown"
        >
        <v-btn
          color="primary"
          round
          :outline="filtroComputed.filtrotipoVeiculoString() == 'Tipo'"
          slot="activator"
          :block="$vuetify.breakpoint.smAndDown"
          >{{ filtroComputed.filtrotipoVeiculoString() }}</v-btn
        >
        <v-card
          :max-width="!$vuetify.breakpoint.smAndDown ? '200px' : ''"
        >
          <v-layout row wrap class="pb-0 pa-3">
            <v-flex
              xs12
              v-for="tipoVeiculo in filtro.tipoVeiculo.opcoes"
              :key="tipoVeiculo.titulo"
            >
              <v-btn
                :color="
                  filtroComputed.tipoVeiculoSelecionadoDescricaoString() ==
                  tipoVeiculo
                    ? 'primary'
                    : 'themeGrey'
                "
                @click="buscarVeiculosTipo(tipoVeiculo.id), filtro.tipoVeiculo.selecionado = tipoVeiculo.titulo"
                round
                block
                :outline="
                  filtroComputed.tipoVeiculoSelecionadoDescricaoString() !=
                    tipoVeiculo
                "
                >{{ tipoVeiculo.titulo }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card>
      </v-menu>
    <v-flex xs12 sm11 md6 lg4>
      <transition name="fade">
        <v-flex xs1 v-if="!filtro.pesquisa.opened">
          <v-btn
            v-if="!filtro.pesquisa.opened"
            @click="filtroFunctions().abrirFiltroPesquisa()"
            color="primary"
            round
            outline
            icon
            ><v-icon>search</v-icon></v-btn
          >
        </v-flex>
        <v-flex v-else>
          <v-text-field
            v-model="filtro.pesquisa.conteudo"
            prepend-icon="search"
            @click:prepend="buscarVeiculoQuery()"
            label="Busca"
            hint="Busca por chassi"
            autofocus
            clearable
            v-on:change="buscarVeiculoQuery()"
          ></v-text-field>
        </v-flex>
      </transition>
    </v-flex>
      </v-card-title>
    <v-card>

      <v-data-table
        :headers="headers"
            :items="veiculosList"
            hide-actions
            :rows-per-page-items="[10]"
            item-key="item"
            class="elevation-0"
      >
        <template  v-slot:items="props">
          <td class="text-xs-center">{{ props.item.placa }}</td>
          <td class="text-xs-center">{{ props.item.chassi }}</td>
          <td class="text-xs-center">{{ props.item.marca }}</td>
          <td class="text-xs-center">{{ props.item.modelo }}</td>
          <td class="text-xs-center">{{formatTipoVeiculo( props.item.idTipoVeiculo) }}</td>
          <td class="justify-center layout px-0" style="position: relative">
            <v-btn color="primary" style="position: absolute; top:0;bottom:0;" fab small dark @click="abrirCadastroVeiculo(props, props.item.placa, props.item.chassi, props.item.fipe )">
                <v-icon
                small
                class="btn-edit-cadastro-veiculos"
                >
                edit
              </v-icon>
            </v-btn>


          </td>
        </template>
        <template v-slot:pageText="props">
           {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-card>
      <div class="text-xs-center pt-2">
            <v-pagination
              v-model="paginacao.page"
              :length="paginacao.totalPages"
              circle
            ></v-pagination>
          </div>
  </v-container>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import perfil from '@/helpers/perfil';
export default {
  name: "GridCadastroVeiculos",
  data() {
    return {
      loading: false,
      selected: null,
      search: '',
      headers: [
        { text: "Placa", value: "placa", align:'center' },
        { text: "Chassi", value: "chassi", align:'center' },
        { text: "Marca", value: "marca", align:'center' },
        { text: "Modelo", value: "modelo", align:'center' },
        { text: "Tipo", value: "nomeTipoVeiculo", align:'center' },
        { text:"Editar", value:"", sorteable: false, align:'center'}
      ],
      paginacao: {
        page: parseInt(sessionStorage.getItem("pageGridVeiculos")),
        rowsPerPage: 10,
        totalItems: 0
      },
      veiculosList: [],
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        },
        tipoVeiculo: {
          opened: false,
          opcoes: [
            {
              id: 0,
              titulo: "Todos"
            },
            {
              id: 1,
              titulo: "Carro"
            },
            {
              id: 2,
              titulo: "Moto"
            },
            {
              id: 3,
              titulo: "Caminhão"
            }
            ],
          selecionado: null,
          selecionadoAtual: null,
        }
      },

    }
  },
  watch: {
    "filtro.pesquisa.conteudo": function(val) {
      if(val.length < 1) {
        this.buscarVeiculos(this.filtro.tipoVeiculo.selecionadoAtual);
      }
    },
    "filtro.tipoVeiculo.selecionado": function(val) {
      this.filtroFunctions().aplicarFiltros();
    },
    "paginacao.page"(val) {
      if(this.filtro.tipoVeiculo.selecionado) {
        this.buscarVeiculosTipo(this.filtro.tipoVeiculo.selecionadoAtual);
      }else {
        this.buscarVeiculos(this.filtro.tipoVeiculo.selecionadoAtual);
      }
      sessionStorage.setItem('pageGridVeiculos', val);
      
    },
    "paginacao.size"() {
      if(this.filtro.tipoVeiculo.selecionadoAtual) {
        this.buscarVeiculosTipo();
      }else {
        this.buscarVeiculos();
      }
    },
  },
  mounted() {
    this.buscarVeiculos();
    if (sessionStorage.getItem("pageGridVeiculos") == null) {
      this.paginacao.page = 1;
    }
  },
  computed: {
    perfilComputed: function() {
      return perfil;
    },

    filtroComputed: function() {
      const self = this;
      return {
        filtrotipoVeiculoString: function() {
          if (self.filtro.tipoVeiculo.selecionado) {
            return self.filtro.tipoVeiculo.selecionado;
          } else {
            return "Tipo";
          }
        },
        tipoVeiculoSelecionadoDescricaoString: function() {
          if (self.filtro.tipoVeiculo.selecionado) {
            return self.filtro.tipoVeiculo.selecionado;
          } else {
            return "";
          }
        }
      };

    }
  },
  methods: {
    buscarVeiculosTipo(idTipoVeiculo) {
      this.filtro.tipoVeiculo.selecionadoAtual = idTipoVeiculo;
      axios
        .get(
          `${process.env.URL_VEICULOMS}/v1/listarVeiculosTipo/${idTipoVeiculo}/?page=${
            this.paginacao.page - 1
          }&size=${this.paginacao.size}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.veiculosList = response.data.content;
          this.paginacao.totalPages = response.data.totalPages;
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarVeiculoQuery() {
      axios
        .get(
          `${process.env.URL_VEICULOMS}/v1/listarVeiculosPorPesquisa/?searchQuery=${this.filtro.pesquisa.conteudo}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.veiculosList = response.data.content;
          this.paginacao.totalPages = response.data.totalPages;
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarVeiculos() {
      this.$store.commit("startLoading");
      axios.get(`${process.env.URL_VEICULOMS}/v1`+ `/?page=${
            this.paginacao.page - 1
          }&size=${this.paginacao.size}`, { headers: {Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`}})
        .then(response => {
          this.veiculosList = response.data.content;
          this.$store.commit("endLoading");
          this.paginacao.totalPages = response.data.totalPages;
        })
        .catch(err => {
          this.$store.commit("endLoading");
        });
    },
    abrirCadastroVeiculo(objeto, placa, chassi, codigoFipe) {
      this.$emit('rowItem', objeto)
      this.$router.push(`/GridCadastroVeiculos/InfoVeiculos?placa=${placa}&chassi=${chassi}&codigoFipe=${codigoFipe}`);
    },

    filtroFunctions: function() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },
    formatTipoVeiculo(tipoVeiculo) {
      if (tipoVeiculo == 1) return "CARRO";
      if (tipoVeiculo == 2) return "MOTO";
      if (tipoVeiculo == 3) return "CAMINHÃO";
      if (tipoVeiculo == 0) return "DESCONHECIDO";
    },
  }
}
</script>

<style>
.container-veiculos-cadastro .theme--light.v-table thead tr:first-child{
  background-color: #00456e;
}
.container-veiculos-cadastro .v-datatable thead th.column {
  color: #FFF!important;

}

.container-veiculos-cadastro table.v-table tbody td {
  padding: 18px 24px;
}

.container-veiculos-cadastro .theme--light.v-datatable thead th.column.sortable .v-icon {
  color: #FFF!important;
}

.container-veiculos-cadastro .theme--light.v-table {
  text-transform: uppercase;
}
.container-veiculos-cadastro .v-list__tile {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/cadastro-veiculos/GridCadastroVeiculos.vue